import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Clock, Users } from 'lucide-react';
import AnimatedElement from '../utils/AnimatedElement';

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center pb-16 pt-32">
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Global Presence Indicators */}
          <AnimatedElement animation="fadeIn" duration={0.6}>
            <div className="flex flex-wrap items-center justify-center gap-6 mb-8 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Globe className="h-4 w-4 text-primary" />
                <span>Serving clients across 15+ countries</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-primary" />
                <span>24/7 support across time zones</span>
              </div>
              <div className="flex items-center gap-2">
                <Users className="h-4 w-4 text-primary" />
                <span>Trusted by 50+ enterprises</span>
              </div>
            </div>
          </AnimatedElement>
          
          {/* Hero Content */}
          <div className="text-center">
            <AnimatedElement animation="slideUp" delay={0.1} duration={0.6}>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
                AI & Data Solutions for{' '}
                <span className="text-primary">Global Enterprises</span>
              </h1>
            </AnimatedElement>
            
            <AnimatedElement animation="slideUp" delay={0.2} duration={0.6}>
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-4 leading-relaxed">
                We build production-ready AI systems, data platforms, and IoT solutions for companies worldwide. 
                We deliver results that matter.
              </p>
            </AnimatedElement>
            
            <AnimatedElement animation="slideUp" delay={0.3} duration={0.6}>
              <p className="text-base text-muted-foreground max-w-xl mx-auto mb-10">
                Founded in 2025. Based in India. Serving clients globally.
              </p>
            </AnimatedElement>
            
            <AnimatedElement animation="slideUp" delay={0.4} duration={0.6}>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a
                  href="https://fictionalstream.zohobookings.in/#/406146000000042072"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="glass-button-primary px-8 py-3 text-base font-medium flex items-center justify-center group"
                >
                  Schedule a Consultation
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
                
                <Link 
                  to="/services" 
                  className="glass-button px-8 py-3 text-base font-medium flex items-center justify-center group"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  View Our Services
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </AnimatedElement>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
